import React, { FC } from 'react';
import { Days } from './date-panel-days';

interface WeekdaysProps {
  weekDays: string[];
  prefix: string;
}

export const Weekdays: FC<WeekdaysProps> = ({ weekDays, prefix }) => {
  return (
    <div className="weekdays">
      {weekDays.map((day) => (
        <div className="day weekday" key={`${prefix}-${day}`}>
          {day}
        </div>
      ))}
    </div>
  );
};
